import React  from 'react';
import PropTypes from 'prop-types';

const PaymentIcon = (props) => {
  const { width, height, isActive } = props;
  let color;
  if (!isActive) {
    color = '#AEB2BF';
  }
  else {
    color = '#FF4200';
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 20">
      <path fill={color} d="M24 5.999V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v3.999h24z"/>
      <path fill={color} d="M0 9v9a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V9H0zm11 6H4v-2h7v2zm9 0h-4v-2h4v2z"/>
    </svg>
  );
};

PaymentIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isActive: PropTypes.bool,
};

PaymentIcon.defaultProps = {
  width: 24,
  height: 20,
  isActive: false,
};

export default PaymentIcon;
